module.exports = __webpack_public_path__ + "img/tipocontacto04.822c264.svg";